/**
 * 回傳網站的Blob網域
 * @param locale: 語系, ENVIRONMENT: 目前的ENV, includeHttps: 是否包含 "https:"
 * @returns String
 */

const provideBlobDomain = (
  locale: EnumLocale,
  ENVIRONMENT?: string,
  includeHttps = true
): string => {
  const https = includeHttps ? 'https:' : '';
  return locale === EnumLocale.ZH_CN
    ? ENVIRONMENT === 'DEVELOPMENT'
      ? `${https}//advcloudfiles.blob.core.chinacloudapi.cn`
      : `${https}//advcloudfiles.advantech.com.cn`
    : ENVIRONMENT === 'DEVELOPMENT'
      ? `${https}//advantechfiles.blob.core.windows.net`
      : `${https}//advcloudfiles.advantech.com`;
};

export default provideBlobDomain;
